import { ref, computed, shallowRef, nextTick } from 'vue'
import { post, get, setValueByPath, getValueByPath } from '../../../utils/index'

export function useQuery({ props, page, keyword, queryData }) {
  const tableRef = ref(null)
  const loading = ref(false)
  // 表格内容数据
  const data = shallowRef([])
  // 表格-复选框
  const selections = shallowRef([]) // 已选择项
  const selectionsMap = new Map() // 中间变量 防止记录重复
  // 表格-数据总数
  const totalCount = ref(null)

  // 选中数据变化时，设置选中项
  const setSelections = (pageNo, records, setTable) => {
    const key = pageNo || page.value.pageNo
    selectionsMap.set(key, records)
    selections.value = [].concat(...selectionsMap.values())
    // 通过表格当前的页数，获取选中的数据，然后反向设置表格的复选框选中状态
    if (setTable) {
      nextTick(() => {
        const pageSelection = selectionsMap.get(key)
        // 设置行选中
        if (pageSelection?.length > 0) tableRef.value?.setCheckboxRow(pageSelection, true)
      })
    }
  }
  // 清空选中项
  const clearSelections = () => {
    selectionsMap.clear() // 清空存储选中数据的辅助map
    selections.value = [] // 清空选中数据
  }

  // 选中全部时触发
  const checkboxAll = ({ records }) => {
    setSelections(page.value.pageNo, records) // 设置选中项
  }

  // 复选选中数据变化时触发
  const checkboxChange = ({ records }) => {
    setSelections(page.value.pageNo, records) // 设置选中项
  }

  // 获取表格内容数据
  const getData = async () => {
    if (!props.dataUrl) return
    loading.value = true
    const methods = { get, post }
    const [res] = await methods[props.dataMethod ?? 'post'](
      props.dataUrl,
      searchParameters.value
    ).finally(() => {
      loading.value = false
    })

    if (props.itemsKey) {
      res.data = getValueByPath(res.data, props.itemsKey) ?? []
    }

    if (res) {
      // 处理返回数据
      data.value = res.data ?? []
      totalCount.value = res.totalCount ?? 0 // 赋值数据总数量

      // 加载表格内容数据
      tableRef.value
        ?.loadDataAsync?.(() => res)
        .then(() => {
          // 获取已选中项的 ids
          const getSelectedIds = () => [...new Set(selections.value.map((im) => im.id))]
          // 根据已选中项 ids，过滤出接口返回的数据中哪些是已选中的项
          const filterSelected = (data, ids) => {
            if (!ids?.length) return []
            return data.filter((im) => ids.includes(im.id))
          }

          // 选中已选项
          setSelections(
            page.value.pageNo,
            filterSelected(res.data, getSelectedIds()),
            [selections.value[0]],
            true
          )
        })
    } else {
      data.value = []
      totalCount.value = 0
    }
  }

  // 重新请求数据
  const reload = () => {
    page.value.pageNo = 1 // 重置页码，设置为 1
    clearSelections() // 清空选中项
    getData()
  }

  // 关键字查询
  const search = async () => {
    page.value.pageNo = 1
    await getData()
  }

  // 查询条件
  const searchParameters = computed(() => {
    const parameters = {
      ...props.dataParameters?.parameters,
    }
    if (queryData && queryData.value) {
      const keys = Object.keys(queryData.value)
      for (const key of keys) {
        if (queryData.value[key] != '' && queryData.value[key] != null) {
          parameters[key] = queryData.value[key]
        }
      }
    }
    const param = {
      criteriaCode: props.criteriaCode,
      ...page.value,
      ...props.dataParameters,
      parameters,
    }

    // 设置关键字
    setValueByPath(param, props.keywordPath, keyword.value)

    return param
  })

  return {
    tableRef,
    totalCount,
    selections,
    loading,
    search,
    getData,
    reload,
    checkboxAll,
    checkboxChange,
    setSelections,
  }
}
